import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class OpenInNewTab extends BaseOption {
  static userInterfaceComponent = {
    label: "Open in new tab",
    component: inspectorTools.RADIO_BAR,
    props: {
      options: [
        {
          label: "Yes",
          value: "yes",
        },
        {
          label: "No",
          value: "no",
        },
      ],
    },
  };

  static defaultValue = "no";

  static convertConfigValueToCompiledValue(configValue) {
    return configValue === "yes";
  }
}
